<template>
    <card-group class="product-reviews-carousel" :hideArrows="paginatedReviews.length < 2">
        <template v-for="slot in ['desktop-view', 'mobile-view']" :slot="slot">
            <v-window-item v-for="(reviewsPage, index) in paginatedReviews" :key="'reviews-page-' + index">
                <v-layout row wrap fill-height>
                    <v-flex
                        v-bind="{['md' + 12 / reviewsPerPageDesktop]: true, ['xs' + 12 / reviewsPerPageMobile]: true}"
                        v-for="review in reviewsPage" :key="'review-' + review.id"
                        class="d-flex"
                    >
                        <product-review-card :review="review"/>
                    </v-flex>
                </v-layout>
            </v-window-item>
        </template>
    </card-group>
</template>

<script>
import ProductReviewCard from './Reviews/ProductReviewCard';

export default {
    name: 'ProductReviews',
    components: {
        ProductReviewCard,
    },
    props: ['reviews'],
    data() {
        return {
            reviewsPerPageDesktop: 3,
            reviewsPerPageMobile: 1,
        };
    },
    computed: {
        paginatedReviews() {
            let paginatedReviews = [];
            let count = 0;

            this.reviews.forEach(review => {
                if (!paginatedReviews[count]) {
                    paginatedReviews[count] = [];
                }

                paginatedReviews[count].push(review);

                if (paginatedReviews[count].length >= this.reviewsPerPage) {
                    count++;
                }
            });

            return paginatedReviews
        },
        reviewsPerPage() {
            return this.$vuetify.breakpoint.mdAndUp ? this.reviewsPerPageDesktop : this.reviewsPerPageMobile;
        },
    },
};
</script>
